module.exports = __webpack_public_path__ + "searchicon.8c63a4cd.svg";